import React from 'react';
export function Mechanism() {
  return <section className="bg-sage text-white py-24 px-6" data-id="element-58">
      <div className="max-w-4xl mx-auto text-center" data-id="element-59">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif mb-8" data-id="element-60">
          The secret isn't "training"—it's the{' '}
          <span className="italic font-semibold" data-id="element-61">Biological Bridge.</span>
        </h2>
        <div className="space-y-6 text-lg md:text-xl font-sans leading-relaxed text-white/90" data-id="element-62">
          <p data-id="element-63">
            This is a 15-minute nervous system transition that moves your baby
            from a state of High Alert to a state of surrendered rest.
          </p>
          <p data-id="element-64">
            By using specific tactile "anchors" and low-frequency regulation,
            you stop fighting their brain and start walking them across the
            bridge to sleep. It’s a clinical, minute-by-minute protocol that
            mimics the safety of the womb to stop the startle reflex and bypass
            the "2 AM Mirror" of stress.
          </p>
        </div>
      </div>
    </section>;
}